import { BaseProfileFetcher } from './base-profile-fetcher';
import { UserProfile } from '../providers/interfaces/profile-fetcher.interface';

export class GitHubProfileFetcher extends BaseProfileFetcher {
  constructor() {
    super('https://api.github.com/user');
  }

  protected mapToUserProfile(rawData: any): UserProfile {
    return {
      email: rawData.email,
      name: rawData.name || rawData.login,
      id: rawData.id?.toString(),
      avatar: rawData.avatar_url,
      username: rawData.login,
      raw: rawData,
    };
  }

  protected getAdditionalHeaders(): Record<string, string> {
    return {
      'User-Agent': 'OAuth2-Token-Manager', // GitHub requires User-Agent
    };
  }
}
